export enum VideoType {
    Vimeo = 'vimeo',
    Youtube = 'youtu',
    Native = 'native'
}

export const supportedSizes = ['200', '300', '700', '1400'];
